// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__7g4h3","label":"SetPasswdForm_label__2Gz_G"};